import { collectErrorMessagesFromFields } from "@sinch/utils/react-hook-form/errorHandling";
import React, { FC } from "react";
import { useMuiController } from "@sinch/components";
import { ConditionInput } from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/ConditionInput/ConditionInput";
import { RateBuilderTreeFormFields } from "@sinch/components/application/RatelistBuilder/ratelistBuilderSchema";
import { RateBuilderRowContentItem } from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/RateBuilderRowContent";

interface RateConditionInputProps {
  rowId: string;
}

export const RateConditionInput: FC<RateConditionInputProps> = ({ rowId }) => {
  const { field, fieldState } = useMuiController<RateBuilderTreeFormFields, `Rate.${string}.condition`>({
    name: `Rate.${rowId}.condition`,
    disableAsReadOnly: true,
  });

  return (
    <RateBuilderRowContentItem className="RateBuilderRowContentItem-full" size="grow">
      <ConditionInput {...field} errorMessage={collectErrorMessagesFromFields(fieldState.error ?? [])} />
    </RateBuilderRowContentItem>
  );
};
